import React from 'react'
import classNames from 'classnames'
import mcss from './Cell.module.scss'

const CLASS = mcss.cell

const Cell: React.FC<
  React.PropsWithChildren<{
    className?: string
    align?: string
  }>
> = ({ className, align, children }) => (
  <div
    className={classNames(CLASS, className, {
      [mcss.bottom]: 'bottom' === align
    })}
  >
    {children}
  </div>
)

export default Cell
